import { todayOffsetToDate } from '../shared'

// カンバンモック画面（ProjectKanban.tsx）向けの保存済み検索条件。
// KanbanV2は保存済み検索条件が無いと hasInitialCondition が false になり、
// 初期検索をスキップ（skipInitialSearch）したうえで検索条件Popperを開いた
// 状態で描画する（KanbanV2/index.tsx）。デモでは一度検索操作を挟まずに
// カードが並んだ状態を見せたいため、保存済み条件がある体でUIStateを返す。
//
// 条件は予定終了日が現在日付の1週間前から3週間後まで。終了日側を広く取るのは、
// デモのWBSが今日以降に予定終了日を持つカードを多く含み、狭い範囲だと
// 初期表示のカードが少なくなるため。デモのWBSは開くたびに今日を基準に
// 日付が組み直される（shared.ts）ため、固定日付ではなく相対で算出しないと
// 時間経過でカードが出なくなる。
// dayOffsetToDateではなくtodayOffsetToDateを使うのは、前者がday 0の曜日
// （水曜）に揃えたデモ日付軸を返し、実際の今日と最大6日ずれるため。
//
// rootUuidは使えない。復元経路の互換アダプタ
// （adaptSearchConditionBefore20230125）が、searchFilterを持たない
// 保存形式からrootUuidを必ず取り除くため、rootUuidだけを返しても
// 復元結果が空になり条件なし扱い（Popperが開いた状態）に戻ってしまう。
export const KANBAN_MOCK_FUNCTION_UUID = 'mock-project-kanban-function-uuid'

const KANBAN_SEARCH_RANGE_PAST_DAYS = 7
const KANBAN_SEARCH_RANGE_FUTURE_DAYS = 21

export const kanbanDefaultSearchCondition = {
  scheduledEndDate: {
    from: todayOffsetToDate(-KANBAN_SEARCH_RANGE_PAST_DAYS),
    to: todayOffsetToDate(KANBAN_SEARCH_RANGE_FUTURE_DAYS),
  },
}

// 担当者ごとのスイムレーン表示。デモでは誰が何を抱えているかを一目で
// 見せたいため、グループ化された状態で開く。
export const KANBAN_SWIMLANE_ENABLED_BY_DEFAULT = true
